import config from './config';

const promotions = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /** Cache duration in hours for product promotions check. */
      productPromotionsCacheTTLInHours: { default: 12, dev: 1 }
    }
  }
});

export default promotions;
